import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

import { IconButtonComponent } from '../button/icon-button.component';
import { IconComponent } from '../icon/icon.component';
import { ArrowLeft, X } from '../icon/icons';

export type HeaderLeading = 'none' | 'back' | 'close';

/**
 * Encabezado de pantalla: tres columnas `44px 1fr 44px` con el título centrado. El título es el `h1` de
 * la pantalla y baja a otro renglón en vez de cortarse. Lo de la derecha se proyecta con `uiHeaderEnd`.
 */
@Component({
  selector: 'ui-header',
  imports: [IconButtonComponent, IconComponent],
  template: `
    <header class="bar">
      <div class="slot">
        @if (leading() !== 'none') {
          <button uiIconButton [label]="leadingLabel()" (click)="leadingClick.emit()">
            <ui-icon [icon]="leadingIcon()" size="1.375rem" />
          </button>
        }
      </div>
      <h1 class="title">{{ title() }}</h1>
      <div class="slot end"><ng-content select="[uiHeaderEnd]" /></div>
    </header>
  `,
  styleUrl: './header.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  readonly title = input.required<string>();
  readonly leading = input<HeaderLeading>('none');
  readonly leadingClick = output<void>();

  protected readonly leadingIcon = computed(() => (this.leading() === 'close' ? X : ArrowLeft));
  protected readonly leadingLabel = computed(() => (this.leading() === 'close' ? 'Cerrar' : 'Regresar'));
}
